import * as actionsTypes from './actionsTypes';

export const changeTypeMovie = () => ({
  type: actionsTypes.CHANGE_TYPE_MOVIE,
});

export const changeTypeTv = () => ({
  type: actionsTypes.CHANGE_TYPE_TV,
});
